/**
 * A global namespace for `Backspace` key.
 * e.which === 8 equivalent
 */
const keyBackspace = 'Backspace';

export default keyBackspace;
